export default __webpack_public_path__ + "c5cfe7354167e0e7694284d3550ba543.png";